<template>
  <div class="section-subportions">
    <b-row class="d-flex align-items-center mb-2 mt-1 px-2">
      <b-col>
        <span class="ap-title ap-title__main">{{ $tc('global.slide', 2) }}</span>
      </b-col>
      <b-col class="d-flex justify-content-end">
        <button
          v-tooltip="$tc('global.cleanFilter')"
          v-shortkey="['ctrl', 'alt', 'f']"
          type="button"
          class="btn btn__icon btn__icon--primary p-0 btn-secondary"
          @shortkey.prevent="cleanFilters"
          @click="cleanFilters"
        >
          <i
            class="far fa-filter"
            aria-hidden="true"
          />
        </button>
        <vt-report-export-buttons
          source="global-search-subportions-grid"
          :export-report="exportReport"
        />
      </b-col>
    </b-row>
    <b-row class="px-1">
      <b-col>
        <vt-grid
          v-if="statesLoaded"
          :row-data="subportions"
          :grid-options="gridOptions"
          class="subportions-grid"
          :column-defs="columnDefs"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VtGrid from '@/components/VtGrid/VtGrid'
import { sectionSubportionGridColumnDefs } from '@/modules/globalLocatorModule/sections/subportion/section-subportion-grid.column-defs'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import subportionService from '@/api/resources/common/commonSubportionServices'
import { GridExportMixin } from '@/mixins/grid-export.mixin'
import { GridUtils } from '@/shared/util/grid-utils'
import { subportionState } from '@/api/resources/entityState/subportion-state'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'

export default {
    name: 'SubportionSection',
    components: {
        VtGrid
    },
    mixins: [
        GridExportMixin
    ],
    props: {
        foundItem: String,
        laboratoryId: { type: Number, required: true },
        caseId: { type: Number, required: true }
    },
    data() {
        return {
            detailCellRendererParams: null,
            subportions: [],
            columnDefs: sectionSubportionGridColumnDefs,
            columns: null,
            statesLoaded: false
        }
    },
    computed: {
        gridOptions() {
            return {
                sideBar: gridSideBarConfig,
                rowModelType: AgGridRowModelType.CLIENT_SIDE,
                onGridReady: this.onGridReady,
                getRowStyle: (params) => {
                    if (params.data.subportionLabel === this.foundItem) {
                        return { background: '#CBF1E3 !important' }
                    }
                }
            }
        }
    },
    watch: {
        async caseId() {
            await this.loadSubportions()
        }
    },
    async created() {
        await subportionState.loadStates()
        this.statesLoaded = true
    },
    methods: {
        cleanFilters() {
            this.gridApi.setFilterModel(null)
        },
        onGridReady({ api }) {
            this.gridApi = api
            this.columnApi = api.columnModel
        },
        async loadSubportions() {
            this.subportions =
                await this.$_toCallSecure(
                    subportionService.getSubportionsByCaseId(this.laboratoryId, this.caseId))
        },
        exportReport(exportType) {
            const columns = this.$_getColumnsToExport(this.gridApi, this.columnApi)
            if (columns && this.gridApi) {
                return subportionService.exportTo(
                    this.laboratoryId,
                    this.caseId,
                    this.foundItem,
                    this.gridApi.getFilterModel(),
                    GridUtils.getSortValue(this.gridApi.getSortModel()),
                    columns,
                    this.gridApi.getSelectedRows()?.map(subportion => {
                        return subportion?.id
                    }),
                    exportType)
            }
            return null
        }
    }
}
</script>

<style lang="scss" scoped>
  .subportions-grid {
  height: calc(100vh - 350px) !important;
}

@media only screen and (max-width: 1366px) and (min-width: 1360px) {
   .subportions-grid {
  height: calc(100vh - 290px) !important;
}
}

</style>

<style lang="scss">
.ag-status-bar{
  display: none;
}

</style>
